<template>
  <div :class="'InputTag_'+id">
    <div class="InputTag-label-input"  >
        <div class="InputTag-tag-box"  ref="tagBox" v-if="ChangeDiv">
            <el-tag v-for="(tag,index) in tags" :key="index" :closable="!disabled" @close="delTag(index)" :type="tag.type"  class="InputTag-tag" >#{{ tag.text }}</el-tag>
        </div>
        <el-input :readonly="isReadonly" :disabled="disabled" :placeholder="TagTextParm.placeholder" v-model="inputData" @focus="handleFocus"  @keydown.enter.native="addTag" @change="addTag()" @blur="CheMandatory()" class="InputTag-tag-input" ></el-input>
        <div v-if="HasError" v-html="ErrorText" class="ErrorTextColor errorWidth" >
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    TagTextParm:{
        type:Object,
        default:function () {
          return {
            placeholder:this.$t("lbl_EMPBE_Companted_Tags_Placeother_Content"),
            errorText:this.$t("lbl_EMPBE_Companted_Tags_Requeid")
          }
        }
      },
    isMandatory:{
        type:Boolean,
        default:true
    },
    checkNull:{
        type:Boolean,
        default:false
    },
    id:{
        type:String,
        default:''
    },
      isReadonly:{
        type:Boolean,
        default:false
    },
    InputStr:{
      type:String,
      default:''
    },
    TagsCount:{
      type:Number,
      default:5
    },
    ChecksData:{
      type:Array,
      default: () => [
        // {type:1,text:'1'},{type:2,text:'2'},{type:3,text:'3'}
      ]
    },
    TagsMargin:{
      type:Number,
      default:10
    },
    RulesMsg:{
      type:Array,
      default:()=>[
        //  {type:1,message:"“{tag}”, cannot duplicate with the term name or synonyms in Theme, Product Category, Application and Hot Search Tag."},
        //  {type:2,message:"“{tag}”, this keyword quota is full."},
        //  {type:3,message:"“{tag}”, cannot be the same as the current company short name on the platform"}
      ]
    },
    disabled: {
      type:Boolean,
      default:false
    }
  },
  data(){
      return {
          inputData:'',
          tags:[],
          SumWidths:0,
          HasError:false,
          ErrorText:'',
          ChangeDiv:true
      }
  },
  watch:{
    checkNull(){
        if(this.checkNull){
          this.CheMandatory();
        }
    },
    ChecksData(){
      this.checkDataMethods();
    },
    HasError(){
      if(this.HasError)
      {
        document.querySelector('.InputTag_'+this.id+ ' .InputTag-tag-input  .el-input__inner').style.setProperty('border-color', '#f56c6c');  
      }
      else
      {
        document.querySelector('.InputTag_'+this.id+ ' .InputTag-tag-input  .el-input__inner').style.setProperty('border-color', '#DCDFE6');   
      }
    }
  },
  computed:{
  },
  mounted(){  
    this.CreatedData();
  },
  methods:{
      CheMandatory(){
          if(!this.isReadonly && this.isMandatory && !this.disabled)
          {
              if(this.tags.length<1)
              {
                this.HasError=true;
                this.ErrorText=this.TagTextParm.errorText;
                this.$emit("noticeMethods")
              }
          }
      },
      handleFocus()
      {
        this.GetAddWidths();
      },
      CreatedData(){
        if(this.InputStr.length>0){
          this.InputStr.split(',').forEach(element => {
            this.tags.push({type:'',text:element})
          });
          
          this.checkDataMethods();
          this.intervalId = setInterval(this.GetAddWidths, 1000); // 每1秒检查一次  
        }
      },
      delTag(index){
        if(this.isReadonly || this.disabled)return;
          this.tags.splice(index,1);
          setTimeout(() => {
            this.GetAddWidths();
          }, 300);
          
          this.checkDataMethods();
          this.CreateStr();
      },
      addTag(){
          if(!this.inputData){
            this.CheMandatory();
            return;
          };
          if(this.tags.length>=this.TagsCount){
            this.inputData = ''
            return;
          } 
          if(this.tags.map(item=>item.text).includes(this.inputData)) 
          {
            this.inputData = '';
            return ;
          }
            this.tags.push({type:'',text:this.inputData})
            this.GetAddWidths();
            this.AddTagsMthods();
            this.inputData = '';
            this.CreateStr();
      },
      AddTagsMthods(){
            this.checkDataMethods();
      },
      checkDataMethods(){
        this.HasError=false;
          if(this.ChecksData.length>0  && this.tags.length>0){
            this.ErrorText="";
             //var tagInclude = this.tags.filter(item=>this.ChecksData.map(item=>item.text).includes(item.text));
             this.ChecksData.forEach(item=>{
                var FindTag =this.tags.find(tagItem=>tagItem.text==item.text);
                if(FindTag)
                {
                  FindTag.type='danger' 
                  this.HasError=true;
                  this.ErrorText+=this.RulesMsg.find(RuleItem=>RuleItem.type==item.type).message+ "<br/>";
                }
             })
          }
          this.$emit("noticeErrorMethods",this.HasError)
      },
      CreateStr(){
        var str = this.tags.map(item=>item.text).join(',');
        this.$emit('ChangeModelStr',str);
      },
      async GetAddWidths(){
        this.$nextTick(()=>{
              var documyhtagbox = document.querySelectorAll('.InputTag_'+this.id+ ' .InputTag-label-input .InputTag-tag')
              var Widths =0;
              for(var i=0;i<documyhtagbox.length;i++)
              {    
                    var offsetWidth = documyhtagbox[i].offsetWidth;
                    Widths += offsetWidth+this.TagsMargin
              }
              Widths+=this.TagsMargin;
              var tagsStyle = document.querySelector('.InputTag_'+this.id+ ' .InputTag-tag-input  .el-input__inner');
              if(tagsStyle)
                tagsStyle.style.paddingLeft =  Widths +'px'
      })
      }
  }
}
</script>
<style lang="scss" scoped>
.InputTag-label-input{
    position: relative;
    .InputTag-tag-box{
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        z-index: 1;
        align-items: center;
        flex-wrap: wrap;
        .InputTag-tag{
            margin-left:10px;
            margin-top: 4px;
        }
    }
}
::v-deep .el-input__inner{
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
}
.ErrorTextColor{
  color: #f56c6c;
}
.errorWidth{
  
  max-width: 400px;
  font-size: 12px;
}

</style>